import { fontAvialableExtentions } from '@hts/shared/consts';
import { reportOnceToSentry } from './sentry.util';

const loadedFontsCache = new Set<string>();
const loadingFontsMap = new Map<string, Promise<string>>();

export const getFontNameByFontFamily = (inputFontFamily: string): string => {
  const lastDotIndex = inputFontFamily.lastIndexOf('.');

  if (lastDotIndex === -1) return inputFontFamily;

  const ext = inputFontFamily.substring(lastDotIndex + 1);

  return fontAvialableExtentions.includes(ext)
    ? inputFontFamily.substring(0, lastDotIndex)
    : inputFontFamily;
};

export const loadFont = async (fontUrl: string, fontFamily: string): Promise<string> => {
  const fontName = getFontNameByFontFamily(fontFamily);
  const cacheKey = `${fontName}__${fontUrl}`;

  if (loadedFontsCache.has(cacheKey)) return fontName;
  if (loadingFontsMap.has(cacheKey)) return loadingFontsMap.get(cacheKey)!;

  const fontPromise = (async () => {
    try {
      const font = new FontFace(fontName, `url("${fontUrl}")`);
      const loadedFont = await font.load();

      document.fonts.add(loadedFont);
      loadedFontsCache.add(cacheKey);

      return fontName;
    } catch (error) {
      const sentryKey = `font_load_failed__${fontName}__${fontUrl}`;

      reportOnceToSentry(sentryKey, `Failed to load font: ${fontName} (${fontUrl})`, 'warning');

      console.error(`Could not load font: ${fontName}`, error);

      return fontName;
    } finally {
      loadingFontsMap.delete(cacheKey);
    }
  })();

  loadingFontsMap.set(cacheKey, fontPromise);

  return fontPromise;
};
